/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/**
	=================================================
	* Theme Name: Layout - Joyeria 
	* Company: Ismart
	* Author: Carlos Rodriguez Suarez 
	=================================================
**/
jQuery(document).ready(function($) {

    var AttieManager = {

        init: function() {
            var attie_data_manager = this;
            attie_data_manager._develope();
        },

        _develope: function() {
            var attie_data_manager = this;
            $('body').addClass('charlie-v2');
          	
          	$(".store-policies-item").on("click", function() {
              $(this).find(".store-policies-description").addClass("active")
            }), $(".icons-scroll-down").click(function() {
              $("html, body").animate({
                scrollTop: $("#store-policies").offset().top
              }, 1e3)
            }), $(".close").on("click", function(e) {
              e.stopPropagation(), $(this).parent().removeClass("active")
            })
        },
    };

    $(document).ready(function() {
        AttieManager.init();
        $(document).on("ajaxStop", function() {
            AttieManager.init();
        });
    });

    $(window).on("load", function() {
        AttieManager.init();
    });
});